
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import VXETable from "vxe-table";

import { addInquirySheet } from "@/api/inquiry";
import { COMPANY_LIST } from "@/constant";
import { searchCustomer } from "@/api/customer";

@Component({
  name: "CreateFee",
})
export default class extends Vue {
  @Prop({ default: "付款单" }) private title: "";
  private form = {
    customerId: null,
    company: null,
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "开票品名",
      prop: "invoiceProductName",
      key: "invoiceProductName",
      show: true,
      disabled: false,
    },
    // {
    //   label: "客人号码",
    //   prop: "guestModel",
    //   key: "guestModel",
    //   show: true,
    //   disabled: false
    // },
    // {
    //   label: "H&Q/JR号码",
    //   prop: "hqOrJrNumber",
    //   key: "hqOrJrNumber",
    //   show: true,
    //   disabled: false
    // },
    // {
    //   label: "OE号码",
    //   prop: "oeNumber",
    //   key: "oeNumber",
    //   show: true,
    //   disabled: false
    // },
    // {
    //   label: "REF号码",
    //   prop: "refNumber",
    //   key: "refNumber",
    //   show: true,
    //   disabled: false
    // },
    {
      label: "开票单位",
      prop: "invoiceUnit",
      key: "invoiceUnit",
      show: true,
      disabled: false,
    },
    {
      label: "数量\n" + "合计数量",
      prop: "totalQuantity",
      key: "totalQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "金额\n" + "合计金额",
      prop: "totalAmount",
      key: "totalAmount",
      show: true,
      disabled: false,
    },
    {
      label: "报关合同号",
      prop: "bookingOrderCode",
      key: "bookingOrderCode",
      show: true,
      disabled: false,
    },
    {
      label: "开票资料号",
      prop: "factoryInvoiceContractCOdes",
      key: "factoryInvoiceContractCOdes",
      show: true,
      disabled: false,
    },
  ] as any;

  private list = [
    {
      label: "公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "请选择公司",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择公司",
        trigger: "change",
      },
      options: COMPANY_LIST,
    },
    {
      label: "客户",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "请选择客户",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      options: [],
      rules: {
        required: true,
        message: "请选择客户",
        trigger: "change",
      },
      labelKey: "abbreviation",
      valueKey: "id",
    },
  ];
  public paymentForm = {
    settlementMethod: "",
    paymentMethod: "",
    accountPeriod: 0,
    paymentRemark: "",
    piAuditor: "",
    internationalTradeTerms: "",
    printLabel: true,
    deposit: true,
    depositAmount: 0,
    depositCurrency: "",
    confirmed: true,
    markList: [],
  } as any;
  private formList = [
    {
      label: "付款单号",
      prop: "paymentMethod",
      key: "paymentMethod",
      type: "select",
      placeholder: "请选择付款方式",
      clearable: true,
      maxlength: 10,
      rules: {
        required: true,
        message: "请选择付款方式",
        trigger: "blur",
      },
      options: [],
      labelKey: "desc",
      valueKey: "name",
    },
    {
      label: "付款金额",
      prop: "paymentRemark",
      key: "paymentRemark",
      type: "input",
      placeholder: "请输入定金金额",
      clearable: true,
      maxlength: 50,
    },
    {
      label: "付款性质",
      prop: "saleDiscount",
      key: "saleDiscount",
      type: "select",
      placeholder: "请选择交易类型",
      clearable: true,
      maxlength: 10,
      options: [],
      labelKey: "desc",
      valueKey: "name",
    },
    {
      label: "付款时间",
      prop: "paymentRemark",
      key: "paymentRemark",
      type: "datetime",
      placeholder: "请输入付款详情",
      clearable: true,
      maxlength: 50,
    },
    {
      label: "付款说明",
      prop: "paymentRemark",
      key: "paymentRemark",
      type: "textarea",
      placeholder: "请输入付款备注",
      clearable: true,
      maxlength: 50,
    },
  ];
  private show = false;

  private close() {
    this.show = false;
    this.$emit("update:show", false);
  }

  private open() {
    this.show = true;
  }

  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            this.addInquirySheet();
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.list[1].options = res;
  }

  //  删除
  public async handleDelete(scope) {
    this.table.list.splice(scope.$index, 1);
  }

  private handleAdd() {
    this.show = true;
  }

  // 新建询价单
  private async addInquirySheet() {
    const { customerId, company } = this.form;
    let params = {
      customerId,
      company,
    };
    try {
      await addInquirySheet(params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }
}
